/* 8 ZYLINDER — theme.js (v3) */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- MONEY FORMATTING ---------- */
  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(window.ThemeLocale || 'de-AT', { style: 'currency', currency: window.ThemeCurrency || 'EUR' }).format(amount);
    } catch (e) {
      return '€' + amount.toFixed(2);
    }
  }

  /* ---------- CART AJAX API ---------- */
  var CartAPI = {
    get: function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (body) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    },
    change: function (body) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }
  };

  var cartItemsEl = document.getElementById('cartDrawerItems');
  var cartSubtotalEl = document.getElementById('cartDrawerSubtotal');

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
    if (!cartItemsEl) return;
    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '<div class="cart-drawer-empty">Dein Warenkorb ist leer.</div>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item, i) {
      html += '' +
        '<div class="cd-item">' +
          '<img src="' + (item.image || '') + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
          '<div>' +
            '<div class="cd-item-title">' + item.product_title + '</div>' +
            '<div class="cd-item-variant">' + (item.variant_title || '') + '</div>' +
            '<div class="cd-item-qty" data-qty-group data-line="' + (i + 1) + '">' +
              '<button type="button" data-qty-minus aria-label="Weniger">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-plus aria-label="Mehr">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-item-right">' +
            '<div class="cd-item-price">' + formatMoney(item.line_price) + '</div>' +
            '<button type="button" class="cd-item-remove" data-line-remove="' + (i + 1) + '">Entfernen</button>' +
          '</div>' +
        '</div>';
    });
    cartItemsEl.innerHTML = html;
  }

  function openCartDrawer() {
    var d = document.getElementById('cartDrawer');
    if (d) { d.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }
  function closeCartDrawer() {
    var d = document.getElementById('cartDrawer');
    if (d) { d.classList.remove('open'); document.body.style.overflow = ''; }
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-qty-plus]');
      var minus = e.target.closest('[data-qty-minus]');
      var remove = e.target.closest('[data-line-remove]');
      if (plus || minus) {
        var group = e.target.closest('[data-qty-group]');
        var line = parseInt(group.getAttribute('data-line'), 10);
        var span = group.querySelector('span');
        var qty = parseInt(span.textContent, 10);
        qty = plus ? qty + 1 : Math.max(0, qty - 1);
        CartAPI.change({ line: line, quantity: qty }).then(renderCart);
      }
      if (remove) {
        var lineR = parseInt(remove.getAttribute('data-line-remove'), 10);
        CartAPI.change({ line: lineR, quantity: 0 }).then(renderCart);
      }
    });
  }

  /* Initial cart state on every page load */
  CartAPI.get().then(renderCart).catch(function () {});

  /* Product forms → AJAX add to cart */
  document.querySelectorAll('[data-ajax-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return CartAPI.get(); })
        .then(function (cart) { renderCart(cart); openCartDrawer(); })
        .catch(function () {})
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = originalText; } });
    });
  });

  /* Quick-add size chips (collection grids) */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa || qa.classList.contains('oos')) return;
    e.preventDefault();
    var variantId = qa.getAttribute('data-variant-id');
    if (!variantId) return;
    var original = qa.textContent;
    qa.textContent = '…';
    CartAPI.add({ id: variantId, quantity: 1 })
      .then(function () { return CartAPI.get(); })
      .then(function (cart) { renderCart(cart); openCartDrawer(); })
      .catch(function () {})
      .finally(function () { qa.textContent = original; });
  });

  /* ---------- SEARCH OVERLAY ---------- */
  var searchOverlay = document.getElementById('searchOverlay');
  if (searchOverlay) {
    document.querySelectorAll('[data-search-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        searchOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
        var input = searchOverlay.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 60);
      });
    });
    var closeSearch = function () {
      searchOverlay.classList.remove('open');
      document.body.style.overflow = '';
    };
    searchOverlay.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
    /* click on the dimmed backdrop itself (not inside the panel) closes it */
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  /* ---------- NAV SCROLL SHADOW ---------- */
  var nav = document.getElementById('mainNav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- MOBILE MENU ---------- */
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var mmClose = document.getElementById('mmClose');
  if (hamburger && mobileMenu) {
    var openMenu = function () { mobileMenu.classList.add('open'); hamburger.classList.add('active'); document.body.style.overflow = 'hidden'; };
    var closeMenu = function () { mobileMenu.classList.remove('open'); hamburger.classList.remove('active'); document.body.style.overflow = ''; };
    hamburger.addEventListener('click', function (e) {
      e.stopPropagation();
      mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
    });
    if (mmClose) mmClose.addEventListener('click', function (e) { e.stopPropagation(); closeMenu(); });
    mobileMenu.querySelectorAll('.mm-sub a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    mobileMenu.querySelectorAll('.mm-item:not(.has-children) > .mm-item-head a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeMenu();
      closeCartDrawer();
      if (searchOverlay) { searchOverlay.classList.remove('open'); document.body.style.overflow = ''; }
    });
  }
  document.querySelectorAll('.mm-item.has-children .mm-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () { btn.closest('.mm-item').classList.toggle('open'); });
  });

  /* ---------- LANGUAGE / ACCOUNT DROPDOWNS ---------- */
  var langWrapper = document.getElementById('langWrapper'), langBtn = document.getElementById('langBtn');
  var accountWrapper = document.getElementById('accountWrapper'), accountBtn = document.getElementById('accountBtn');
  if (langBtn && langWrapper) {
    langBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (accountWrapper) accountWrapper.classList.remove('open');
      langWrapper.classList.toggle('open');
    });
    langWrapper.querySelectorAll('.lang-option').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        langWrapper.querySelectorAll('.lang-option').forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
        langWrapper.classList.remove('open');
      });
    });
  }
  if (accountBtn && accountWrapper) {
    accountBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (langWrapper) langWrapper.classList.remove('open');
      accountWrapper.classList.toggle('open');
    });
  }
  document.addEventListener('click', function () {
    if (langWrapper) langWrapper.classList.remove('open');
    if (accountWrapper) accountWrapper.classList.remove('open');
  });

  /* ---------- COLLECTION-ROW CAROUSELS ---------- */
  document.querySelectorAll('[data-crow]').forEach(function (crow) {
    var scroller = crow.querySelector('[data-crow-scroller]');
    if (!scroller) return;
    var prev = crow.querySelector('[data-crow-prev]'), next = crow.querySelector('[data-crow-next]');
    var amount = function () { return scroller.clientWidth * 0.85; };
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: amount(), behavior: 'smooth' }); });
  });

  /* ---------- GENERIC GALLERY (product page) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    var imgs = main.querySelectorAll('img[data-index]');
    var thumbsWrap = gallery.querySelector('[data-gallery-thumbs]');
    var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-index]') : [];
    if (!imgs.length) return;
    var cur = 0;
    function goTo(i) {
      imgs[cur].classList.remove('active');
      if (thumbs[cur]) thumbs[cur].classList.remove('active');
      cur = (i + imgs.length) % imgs.length;
      imgs[cur].classList.add('active');
      if (thumbs[cur]) thumbs[cur].classList.add('active');
    }
    var prev = gallery.querySelector('[data-gallery-prev]'), next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10)); }); });
    var touchX = 0;
    main.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      var diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? cur + 1 : cur - 1);
    });
  });

  /* ---------- GENERIC SIZE SELECTOR ---------- */
  document.querySelectorAll('[data-size-group]').forEach(function (group) {
    var addBtn = document.getElementById(group.dataset.addTarget || '');
    var variantInput = document.getElementById(group.dataset.variantTarget || '');
    group.querySelectorAll('[data-size-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        group.querySelectorAll('[data-size-btn]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (variantInput && btn.dataset.variantId) variantInput.value = btn.dataset.variantId;
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.label || 'In den Warenkorb';
        }
      });
    });
  });

  /* ---------- GENERIC ACCORDION ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.querySelectorAll('[data-acc-trigger]').forEach(function (trigger) {
      var item = trigger.closest('[data-acc-item]');
      if (!item) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        acc.querySelectorAll('[data-acc-item]').forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  });
  document.querySelectorAll('[data-acc-open]').forEach(function (opener) {
    opener.addEventListener('click', function () {
      var item = document.getElementById(opener.getAttribute('data-acc-open'));
      if (!item) return;
      var acc = item.closest('[data-accordion]');
      if (acc) acc.querySelectorAll('[data-acc-item]').forEach(function (i) { i.classList.remove('open'); });
      item.classList.add('open');
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* ---------- PRODUCT CARD HOVER-CYCLE ---------- */
  document.querySelectorAll('.pcard').forEach(function (card) {
    var imgs = card.querySelectorAll('.pcard-media img');
    if (imgs.length < 2) return;
    var idx = 0, timer = null;
    card.addEventListener('mouseenter', function () {
      timer = setInterval(function () {
        imgs[idx].classList.remove('pc-active');
        idx = (idx + 1) % imgs.length;
        imgs[idx].classList.add('pc-active');
      }, 750);
    });
    card.addEventListener('mouseleave', function () {
      clearInterval(timer);
      imgs.forEach(function (im, i) { im.classList.toggle('pc-active', i === 0); });
      idx = 0;
    });
  });

  /* ---------- SCROLL REVEAL ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: .12 });
    revealEls.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- SORT SELECT (collection page) ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }


  /* ---------- COME-BACK TAB (Titel + Favicon wechseln, wenn der Tab verlassen wird) ---------- */
  (function () {
    var cfg = window.ThemeTabAway;
    if (!cfg || !cfg.enabled || !cfg.text) return;

    var originalTitle = document.title;
    var faviconEl = document.getElementById('siteFavicon');
    var away = false;

    function goAway() {
      if (away) return;
      away = true;
      originalTitle = document.title === cfg.text ? originalTitle : document.title;
      document.title = cfg.text;
      if (faviconEl && cfg.favicon) faviconEl.setAttribute('href', cfg.favicon);
    }

    function comeBack() {
      if (!away) return;
      away = false;
      document.title = originalTitle;
      if (faviconEl && cfg.favicon) faviconEl.setAttribute('href', cfg.faviconDefault);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { goAway(); } else { comeBack(); }
    });
    window.addEventListener('blur', goAway);
    window.addEventListener('focus', comeBack);
  })();

});
